<template>
<v-layout>
  <v-flex>
  <v-card flat>
            <v-card-title>
      <h3 class="headline mb-0 admin-header">Drivers</h3>
      <v-btn text icon color="grey lighten-1" @click="refresh"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
        <v-data-table
            :items="collectordrivers"
            item-key="id"
            :search="search"
            :loading="loading"
            :headers="headers"
            :options.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:item.schedule.lastRunTime="{item}">
              <td>{{item.schedule && formatTimeValue(item.schedule.lastRunTime)}}</td>
            </template>
            <template v-slot:item.schedule.nextRunTime="{item}">
              <td>{{item.schedule && formatTimeValue(item.schedule.nextRunTime)}}</td>
            </template>
            <template v-slot:item.buildInfo.git.build.time="{item}">
              <td>{{formatTimeValue(item.buildInfo['git.build.time'])}}</td>
            </template>
            <template v-slot:item.buildInfo.git.commit.id.abbrev="{item}">
              <td>{{item.buildInfo['git.commit.id.abbrev']}}</td>
            </template>
          </v-data-table>
        </v-card>
        </v-flex>
        </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      search: '',
      pagination : {'sortBy': ['systemType'], 'rowsPerPage': 10},
      headers: [
        {text:'Document Type', value: 'documentType'},
        {text:'System Type', value: 'systemType'},
        {text: 'Polling', value: 'polling'},
        {text: 'Version', value: 'version'},
        {text: 'System Id', value: 'systemId'},
        {text: 'File Path', value: 'jar.path'},
        {text: 'Hr', value: 'schedule.hour'},
        {text: 'Min', value: 'schedule.minute'},
        {text: 'Last Run', value: 'schedule.lastRunTime'},
        {text: 'Next Run', value: 'schedule.nextRunTime'},
        {text: 'Active', value: 'active'},
        {text: 'Build Time', value: 'buildInfo.git.build.time'},
        {text: 'Build Commit', value: 'buildInfo.git.commit.id.abbrev'}
      ]
    }
  },
  watch: {
    orgContext: async function(val) {
      this.loading = true
      await this.$store.dispatch('collectors/getDrivers')
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('collectors', {
        collectordrivers: 'getDrivers'
    }),
    ...mapGetters('user', {
        orgContext: 'getOrgContext'
    })
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('collectors/getDrivers')
    this.loading = false
  },
  methods: {
    async refresh() {
      await this.$store.dispatch('collectors/getDrivers', true)
    },
    formatTimeValue(val) {
      if (!val) {
        return ''
      }
      return moment(val).format('MM/DD/YYYY, h:mm:ss a')
    }
  }
}
</script>
